"use client";

import Lottie from "lottie-react";
import sandyLoadingAnim from "@public/assets/animations/cra_loading_5.json";
import { useEffect, useMemo, useState } from "react";

interface SandyLoadingScreenProps {
    text?: string;
    subText?: string;
    rotatingSubTexts?: string[];
    size?: number;
}

const SandyLoadingScreen = ({ text, subText, rotatingSubTexts = [], size = 220 }: SandyLoadingScreenProps) => {
    const subTextOptions = useMemo(
        () => rotatingSubTexts.filter((item): item is string => typeof item === "string" && item.trim().length > 0),
        [rotatingSubTexts],
    );
    const rotationKey = useMemo(() => subTextOptions.join("||"), [subTextOptions]);
    const [currentSubTextIndex, setCurrentSubTextIndex] = useState(0);
    const [isSubTextVisible, setIsSubTextVisible] = useState(true);

    useEffect(() => {
        if (subTextOptions.length === 0) {
            setCurrentSubTextIndex(0);
            setIsSubTextVisible(true);
            return;
        }

        setCurrentSubTextIndex(Math.floor(Math.random() * subTextOptions.length));
        setIsSubTextVisible(true);
    }, [rotationKey, subTextOptions.length]);

    useEffect(() => {
        if (subTextOptions.length <= 1) {
            return;
        }

        let fadeTimeout: number | undefined;
        const interval = window.setInterval(() => {
            setIsSubTextVisible(false);
            fadeTimeout = window.setTimeout(() => {
                setCurrentSubTextIndex((prevIndex) => (prevIndex + 1) % subTextOptions.length);
                setIsSubTextVisible(true);
            }, 300);
        }, 3000);

        return () => {
            window.clearInterval(interval);
            if (fadeTimeout) {
                window.clearTimeout(fadeTimeout);
            }
        };
    }, [subTextOptions.length, rotationKey]);

    const activeSubText = subTextOptions.length > 0 ? subTextOptions[currentSubTextIndex] : subText;

    return (
        <div className="flex flex-col items-center justify-center">
            <Lottie
                animationData={sandyLoadingAnim}
                loop
                autoplay
                style={{ width: size, height: size }}
            />
            {text && (
                <h3 className="text-xl font-bold text-[#2A807B] mt-2">{text}</h3>
            )}
            {activeSubText && (
                <p
                    className={`text-[#006F64] text-sm mt-1 min-h-[20px] text-center transition-opacity duration-500 ${
                        isSubTextVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    {activeSubText}
                </p>
            )}
        </div>
    );
};

export default SandyLoadingScreen;
